// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as ApiUtils$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/utils/ApiUtils.mjs";
import * as ErrorUtils$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/utils/ErrorUtils.mjs";
import * as Sentry$PorterinUtils from "../../../../../../../node_modules/@porterin/utils/src/bindings/sentry/Sentry.mjs";
import * as CookieUtils$PorterinFeature from "../../../../containers/fare-estimate-v1/utils/browser/CookieUtils.mjs";
import * as AuthRepoManager$PorterinFeature from "../../../../containers/login/domain/repo/AuthRepoManager.mjs";

function logoutHandler(set_user, set_is_authenticated, set_is_mobile_menu_open) {
  var RepoInstance = AuthRepoManager$PorterinFeature.getAuthRepo(undefined);
  var match = CookieUtils$PorterinFeature.getAuthCookies(undefined);
  var mobile = match[2];
  var auth_token = match[1];
  var web_tracking_id = match[0];
  ApiUtils$Catalyst.handleAPIRequest((function (param) {
          return Curry._3(RepoInstance.customerLogout, web_tracking_id, auth_token, mobile);
        }), (function (data) {
          if (data.logout_success) {
            CookieUtils$PorterinFeature.deleteCookie("auth-token");
            CookieUtils$PorterinFeature.deleteCookie("mobile");
            Curry._1(set_user, undefined);
            Curry._1(set_is_authenticated, false);
            return Curry._1(set_is_mobile_menu_open, (function (prev) {
                          return !prev;
                        }));
          }
          
        }), (function (error) {
          Sentry$PorterinUtils.captureException(ErrorUtils$Catalyst.resolveError(error));
        }));
}

export {
  logoutHandler ,
}
/* Sentry-PorterinUtils Not a pure module */
